/**
 * Mock SSOT for HotelsRiver package-profile UI demo.
 * Derived from existing /packages/profile sections + packages-results mock package.
 * No API / no booking side-effects.
 */

export const MOCK_PROFILE_PACKAGE = {
  id: "pkg-7seasons",
  dealId: "MOCK-DEAL-7SEASONS",
  hotelName: "7SEASONS APARTMENTS",
  stars: 4,
  city: "בודפשט",
  country: "הונגריה",
  address: "Andrássy út 12, Budapest",
  phone: "+36 1 555 0123",
  website: "https://example.com/hotel",
  surfersRating: "8.6",
  description:
    "דירות סטודיו במרכז בודפשט, קרוב לשדרת אנדראשי. כולל מטבחון, Wi‑Fi וקבלת פנים 24/7.",
  boardId: "bb",
  boardLabel: "ארוחת בוקר",
  nights: 4,
  checkInLabel: "15/11/2026",
  checkOutLabel: "19/11/2026",
  dateRangeLabel: "15 - 19 נובמבר 2026",
  currency: "EUR",
  /** שער ברגע ההזמנה — כמו exchange_rate_at_booking בפרופיל הפעיל */
  exchangeRateAtBooking: {
    usdToIls: 3.089,
    eurToIls: 3.46,
    display: "1 USD = ₪3.089",
  },
  agentNetPerPerson: 638,
  agentNetPerPersonIls: 2210,
  immediateConfirm: true,
  transferIncluded: false,
  baggage: {
    bullets: ['טרולי 8 ק"ג כלול'],
  },
  gallery: [
    "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=1200&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=1200&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=1200&q=80&auto=format&fit=crop",
  ],
  amenitiesGroupsCount: 4,
  hotelRemarksHtml:
    "<p>צ׳ק־אין מ־15:00. נדרש דרכון בתוקף. המחיר כולל ארוחת בוקר.</p>",
  flightOptions: [
    {
      id: "flight-a",
      label: "אפשרות א׳",
      outbound: {
        from: "TLV",
        to: "BUD",
        depart: "06:40",
        arrive: "09:55",
        airline: "Wizz Air",
        airlineCode: "W6",
        flightNo: "W6 246",
        duration: "3ש 15ד",
        seatsLeft: 3,
      },
      inbound: {
        from: "BUD",
        to: "TLV",
        depart: "22:10",
        arrive: "01:55+1",
        airline: "Wizz Air",
        airlineCode: "W6",
        flightNo: "W6 247",
        duration: "3ש 45ד",
        seatsLeft: 5,
      },
    },
    {
      id: "flight-b",
      label: "אפשרות ב׳",
      outbound: {
        from: "TLV",
        to: "BUD",
        depart: "10:15",
        arrive: "13:30",
        airline: "El Al",
        airlineCode: "LY",
        flightNo: "LY 2365",
        duration: "3ש 15ד",
        seatsLeft: 9,
      },
      inbound: {
        from: "BUD",
        to: "TLV",
        depart: "14:45",
        arrive: "18:20",
        airline: "El Al",
        airlineCode: "LY",
        flightNo: "LY 2366",
        duration: "3ש 35ד",
        seatsLeft: 8,
      },
    },
  ],
  rooms: [
    {
      id: "room-studio",
      name: "סטודיו",
      boardLabel: "ארוחת בוקר",
      capacityLabel: "2 מבוגרים",
      adults: 2,
      children: 0,
      deltaPerPersonIls: 0,
      roomTotalIls: 4420,
      immediateConfirm: true,
      allowInfants: true,
      maxInfants: 1,
      infantSurchargeIls: 180,
    },
    {
      id: "room-superior",
      name: "סטודיו סופיריור",
      boardLabel: "ארוחת בוקר",
      capacityLabel: "2 מבוגרים",
      adults: 2,
      children: 0,
      deltaPerPersonIls: 155,
      roomTotalIls: 4730,
      immediateConfirm: true,
      allowInfants: true,
      maxInfants: 1,
      infantSurchargeIls: 180,
    },
    {
      id: "room-request",
      name: "דירת משפחה",
      boardLabel: "ארוחת בוקר",
      capacityLabel: "2 מבוגרים + ילד",
      adults: 2,
      children: 1,
      deltaPerPersonIls: 310,
      roomTotalIls: 5350,
      immediateConfirm: false,
      allowInfants: false,
      maxInfants: 0,
      infantSurchargeIls: 0,
    },
  ],
  supplements: [
    {
      id: "supp-seat",
      label: "בחירת מושב מראש",
      priceIls: 120,
      priceFx: 35,
    },
    {
      id: "supp-bag",
      label: 'מזוודה 23 ק"ג נוספת',
      priceIls: 280,
      priceFx: 80,
    },
  ],
  /** Like PackagePriceSelector occupancy cards */
  addRoomPresets: [
    {
      id: "add-2a",
      label: "2 מבוגרים",
      adults: 2,
      children: 0,
      priceIls: 4420,
      priceFx: 1406,
      allowInfants: true,
      maxInfants: 1,
      infantSurchargeIls: 180,
      roomName: "סטודיו",
    },
    {
      id: "add-2a1c",
      label: "2 מבוגרים + ילד",
      adults: 2,
      children: 1,
      priceIls: 5350,
      priceFx: 1702,
      allowInfants: false,
      maxInfants: 0,
      infantSurchargeIls: 0,
      roomName: "דירת משפחה",
    },
    {
      id: "add-3a",
      label: "3 מבוגרים",
      adults: 3,
      children: 0,
      priceIls: 6120,
      priceFx: 1947,
      allowInfants: true,
      maxInfants: 1,
      infantSurchargeIls: 180,
      roomName: "חדר משולש",
    },
  ],
  additionalInfoHtml:
    "<p>צ׳ק־אין מ־15:00. נדרש דרכון בתוקף לכל הנוסעים. המחיר כולל ארוחת בוקר.</p><p>המלון ממוקם במרכז בודפשט — כ־10 דק׳ הליכה מהאופרה.</p>",
  disclosureItems: [
    "שינוי או ביטול הזמנה כרוכים בדמי טיפול של החברה בסך 85$ לנוסע, בנוסף לדמי הביטול של הספק.",
    "המחיר והזמינות סופיים רק לאחר אישור הספק ושובר.",
    "תנאי הביטול והשינוי נקבעים בלעדית על ידי הספק ועלולים לכלול חיובים מלאים.",
    "ייתכנו אי־דיוקים במידע ובתמונות.",
    "הסוכן מחויב להעביר ללקוח את כל תנאי ההזמנה בצורה מלאה וברורה.",
  ],
  attractionsNote:
    "אטרקציות יוצגו לאחר בחירת חבילה ויעד מתאימים לחיפוש — כמו בעמוד הפעיל.",
  attractionsDemo: [
    { id: "att-1", title: "שייט בדנובה", priceIls: 180 },
    { id: "att-2", title: "כניסה למצודה", priceIls: 95 },
  ],
  /** Mirrors TripGuarantyInsurance UI — mock quote only, no API */
  tripGuaranty: {
    priceIls: 186,
    coverageIls: 4420,
    hebrewMessage: "כיסוי לביטול נסיעה ואירועים רפואיים לפי תנאי הפוליסה.",
    availableFromNote: "זמין לנסיעות מ-01.08.2025 ואילך",
  },
};

export const MOCK_PROFILE_STAGES = [
  { id: "details", label: "פרטי החבילה", active: true },
  { id: "payment", label: "ביצוע תשלום", active: false, stub: true },
  { id: "summary", label: "אישור וסיכום הזמנה", active: false, stub: true },
];

export const MOCK_PROFILE_SECTIONS = [
  { id: "overview", label: "סקירה" },
  { id: "flights", label: "טיסות" },
  { id: "rooms", label: "חדרים" },
  { id: "add-rooms", label: "הוספת חדרים" },
  { id: "passengers", label: "נוסעים" },
  { id: "extras", label: "תוספות" },
  { id: "insurance", label: "ביטוח" },
  { id: "disclosure", label: "גילוי נאות" },
];

const HPM_PAX_CLIPBOARD_KEY = "hpm-mock-passengers-clipboard";

export function readMockPassengersClipboard() {
  try {
    const raw = sessionStorage.getItem(HPM_PAX_CLIPBOARD_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed?.passengers) ? parsed : null;
  } catch {
    return null;
  }
}

export function writeMockPassengersClipboard(passengers) {
  sessionStorage.setItem(
    HPM_PAX_CLIPBOARD_KEY,
    JSON.stringify({ passengers, savedAt: Date.now() })
  );
}

export function formatFx(amount, currency = "EUR") {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "";
  const formatted = Math.round(n).toLocaleString("en-US");
  return currency === "USD" ? `$${formatted}` : `€${formatted}`;
}

export function formatIls(amount) {
  return `₪${Number(amount).toLocaleString("he-IL")}`;
}
